var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0922 25.6459H1.97227C1.81666 25.6459 1.69052 25.5198 1.69052 25.3642V22.5466H34.3739V25.3642C34.3739 25.5198 34.2478 25.6459 34.0922 25.6459H34.0922ZM21.695 34.662H14.3694V27.3364H21.695V34.662ZM1.97227 1.97862H34.0922C34.2478 1.97862 34.3739 2.10477 34.3739 2.26037V20.8561H1.69051V2.26037C1.69051 2.10476 1.81666 1.97862 1.97226 1.97862H1.97227ZM34.0922 0.288086H1.97227C0.88301 0.288086 0 1.17111 0 2.26037V25.3642C0 26.4534 0.88302 27.3364 1.97228 27.3364H12.6789V34.662H8.17085C7.70403 34.662 7.32559 35.0405 7.32559 35.5073C7.32559 35.9741 7.70403 36.3525 8.17085 36.3525H27.8936C28.3604 36.3525 28.7389 35.9741 28.7389 35.5073C28.7389 35.0405 28.3604 34.662 27.8936 34.662H23.3855V27.3364H34.0922C35.1814 27.3364 36.0645 26.4534 36.0645 25.3642V2.26038C36.0645 1.17112 35.1814 0.288106 34.0922 0.288106L34.0922 0.288086Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ac31fb08ae6c75569694d6d904a41bd9.svg";
export { ForwardRef as ReactComponent };